import ArrowForwardIosOutlined from '@mui/icons-material/ArrowForwardIosOutlined';
import { Button, ButtonProps, Typography } from '@mui/material';

import { HStack } from '../../Stack';

/**
 * 페이지 안에서 사용하는 메뉴의 아이템.
 *
 * @package
 */
export const MenuItem = ({
  children,
  disabled,
  ...buttonProps
}: { children?: React.ReactNode; disabled?: boolean } & ButtonProps) => {
  return (
    <HStack bgcolor={'white'} height={56} alignItems={'center'}>
      <Button
        {...buttonProps}
        variant="text"
        color="inherit"
        disabled={disabled}
        sx={{ flex: 1, justifyContent: 'space-between', alignItems: 'center', p: 2 }}
      >
        <Typography variant="Body_Looko">{children}</Typography>
        <ArrowForwardIosOutlined sx={{ fontSize: 16 }} />
      </Button>
    </HStack>
  );
};
